'use client';

import { Profiler, ReactNode } from 'react';
import { DetailPanelProvider } from '@/contexts/DetailPanelContext';
import { ProjectProvider } from '@/contexts/ProjectContext';
import type { InitialProjectState } from '@/types/projects';
import { AuthProvider } from '../auth-provider';

interface AppProvidersProps {
  children: ReactNode;
  blockUntilAuthResolved?: boolean;
  allowSessionCookieAuth?: boolean;
  initialProjectState?: InitialProjectState | null;
}

export function AppProviders({
  children,
  blockUntilAuthResolved = false,
  allowSessionCookieAuth = false,
  initialProjectState = null,
}: AppProvidersProps) {
  const content = (
    <AuthProvider blockUntilResolved={blockUntilAuthResolved}>
      <ProjectProvider
        allowSessionCookieAuth={allowSessionCookieAuth}
        initialProjectState={initialProjectState}
      >
        <DetailPanelProvider>{children}</DetailPanelProvider>
      </ProjectProvider>
    </AuthProvider>
  );
  if (
    process.env.NODE_ENV !== 'development' ||
    process.env.NEXT_PUBLIC_ATTUNE_RENDER_DIAGNOSTICS !== 'true'
  )
    return content;
  return (
    <Profiler
      id="workspace"
      onRender={(id, phase, actualDuration, baseDuration, startTime, commitTime) => {
        console.debug(
          '[render-diagnostics]',
          JSON.stringify({ id, phase, actualDuration, baseDuration, startTime, commitTime })
        );
      }}
    >
      {content}
    </Profiler>
  );
}
